import * as React from "react";
import { HashRouter as Router, Route } from "react-router-dom";
import "./style/App.scss";
import NavBar from "./components/NavBar";
import Icon from "./packages/icon/Icon";
import Introduction from "./components/Introduction";
import Color from "./components/Color";
import ZIndex from "./components/ZIndex";
import Start from "./components/Start";
import ButtonExample from "./examples/Button.example";
import GridExample from "./examples/Grid.example";
import InputExample from "./examples/Input.example";
import SwitchExample from "./examples/Switch.example";
import RadioExample from "./examples/Radio.example";
import RateExample from "./examples/Rate.example";
import PopoverExample from "./examples/Popover.example";
import SlidesExample from "./examples/Slides.example";
import PagerExample from "./examples/Pager.example";
import TransitionExample from "./examples/Transition.example";
import TabsExample from "./examples/Tabs.example";
import CollapseExample from "./examples/Collapse.example";
import MenuExample from "./examples/Menu.example";
import ModalExample from "./examples/Modal.example";
import DatePickerExample from "./examples/DatePicker.example";
import CascaderExample from "./examples/Cascader.example";
import LightUpExample from "./examples/LightUp.example";
import MessageExample from "./examples/Message.example";
import TableExample from "./examples/Table.example";
import AffixExample from "./examples/Affix.example";
import ScrollExample from "./examples/Scroll.example";
import SpinExample from "./examples/Spin.example";
import WaterfallExample from "./examples/Waterfall.example";
import VirtualTableExample from "./examples/VirtualTable.example";
import CheckBoxExample from "./examples/CheckBox.example";

class App extends React.Component {
  public render() {
    return (
      <Router>
        <div className="App">
          <header className="header">
            <div className="logo">
              <span className="icon-wrapper">
                <Icon name="snow" style={{ fill: "#1890ff" }} size={24} />
              </span>
              <span className="text">Xue-react</span>
            </div>
            <div
              className="github"
              onClick={() =>
                window.open("https://github.com/BlameDeng/xue-react", "_blank")
              }
            >
              <Icon
                name="github"
                style={{
                  fill: "rgba(0,0,0,0.85)"
                }}
                size={24}
              />
            </div>
          </header>
          <main className="main">
            <Route path="/" component={NavBar} />
            <div className="container">
              <Route path="/introduction" component={Introduction} />
              <Route path="/color" component={Color} />
              <Route path="/zindex" component={ZIndex} />
              <Route path="/start" component={Start} />
              <Route path="/components/button" component={ButtonExample} />
              <Route path="/components/grid" component={GridExample} />
              <Route path="/components/input" component={InputExample} />
              <Route path="/components/switch" component={SwitchExample} />
              <Route path="/components/radio" component={RadioExample} />
              <Route path="/components/rate" component={RateExample} />
              <Route path="/components/popover" component={PopoverExample} />
              <Route path="/components/slides" component={SlidesExample} />
              <Route path="/components/pager" component={PagerExample} />
              <Route path="/components/tabs" component={TabsExample} />
              <Route path="/components/collapse" component={CollapseExample} />
              <Route path="/components/message" component={MessageExample} />
              <Route path="/components/modal" component={ModalExample} />
              <Route path="/components/affix" component={AffixExample} />
              <Route path="/components/menu" component={MenuExample} />
              <Route path="/components/cascader" component={CascaderExample} />
              <Route path="/components/table" component={TableExample} />
              <Route path="/components/scroll" component={ScrollExample} />
              <Route path="/components/spin" component={SpinExample} />
              <Route
                path="/components/virtualtable"
                component={VirtualTableExample}
              />
              <Route
                path="/components/waterfall"
                component={WaterfallExample}
              />
              <Route
                path="/components/datepicker"
                component={DatePickerExample}
              />
              <Route
                path="/components/transition"
                component={TransitionExample}
              />
              <Route path="/components/lightup" component={LightUpExample} />
              <Route path="/components/checkbox" component={CheckBoxExample} />
            </div>
          </main>
          <footer className="footer">
            <ul className="footer-link">
              <li
                onClick={() =>
                  window.open(
                    "https://github.com/BlameDeng/xue-react",
                    "_blank"
                  )
                }
              >
                <span className="icon-wrapper">
                  <Icon name="github" size={16} />
                </span>
                Github
              </li>
              <li
                onClick={() =>
                  window.open("https://github.com/BlameDeng/xue-ui", "_blank")
                }
              >
                <span className="icon-wrapper">
                  <Icon name="snow" size={16} />
                </span>
                Xue-ui
              </li>
            </ul>
          </footer>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx